import { useQuery } from 'react-query';
import { useSelector } from 'react-redux';
import { authFetch } from '../../CommonUtils/authFetch';
import { urlWithParams } from '../../CommonUtils/urlWithParams';
import { routeParamsSelector } from '../../CommonComponents/Router/Selector';

export enum PaymentOptionsDTO {
  CreditCard = 'CreditCard',
  ACH = 'ACH',
}

type PaymentOption = keyof typeof PaymentOptionsDTO;

interface PaymentDTO {
  currentPaymentOption: PaymentOptionsDTO | null;
  maskedNumber: string | null;
  paymentOptions: PaymentOption[];
}

const fetchPayment = async (clientId: string): Promise<PaymentDTO> => {
  return authFetch(
    urlWithParams('/Consumer/BluePay/GetPaymentInformation', {
      clientId,
    }),
  );
};

export const PAYMENT_QUERY_KEY = 'payment';

export const usePaymentQuery = () => {
  const { clientId } = useSelector(routeParamsSelector);

  return useQuery([PAYMENT_QUERY_KEY, clientId], () => fetchPayment(clientId));
};
